import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTaxTariffTranches } from 'app/entities/tax-tariff-tranche/tax-tariff-tranche.reducer';
import { createEntity, getEntity, reset, updateEntity } from './tax-tariff-tranche-history.reducer';

export const TaxTariffTrancheHistoryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const taxTariffTranches = useAppSelector(state => state.taxTariffTranche.entities);
  const taxTariffTrancheHistoryEntity = useAppSelector(state => state.taxTariffTrancheHistory.entity);
  const loading = useAppSelector(state => state.taxTariffTrancheHistory.loading);
  const updating = useAppSelector(state => state.taxTariffTrancheHistory.updating);
  const updateSuccess = useAppSelector(state => state.taxTariffTrancheHistory.updateSuccess);

  const handleClose = () => {
    navigate('/tax-tariff-tranche-history');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTaxTariffTranches({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.tariff !== undefined && typeof values.tariff !== 'number') {
      values.tariff = Number(values.tariff);
    }

    const entity = {
      ...taxTariffTrancheHistoryEntity,
      ...values,
      taxTariffTrancheType: taxTariffTranches.find(it => it.id.toString() === values.taxTariffTrancheType?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...taxTariffTrancheHistoryEntity,
          taxTariffTrancheType: taxTariffTrancheHistoryEntity?.taxTariffTrancheType?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="crawlerBackendApp.taxTariffTrancheHistory.home.createOrEditLabel"
            data-cy="TaxTariffTrancheHistoryCreateUpdateHeading"
          >
            <Translate contentKey="crawlerBackendApp.taxTariffTrancheHistory.home.createOrEditLabel">
              Create or edit a TaxTariffTrancheHistory
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tax-tariff-tranche-history-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.taxTariffTrancheHistory.tariff')}
                id="tax-tariff-tranche-history-tariff"
                name="tariff"
                data-cy="tariff"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.taxTariffTrancheHistory.effectiveDate')}
                id="tax-tariff-tranche-history-effectiveDate"
                name="effectiveDate"
                data-cy="effectiveDate"
                type="date"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.taxTariffTrancheHistory.expirationDate')}
                id="tax-tariff-tranche-history-expirationDate"
                name="expirationDate"
                data-cy="expirationDate"
                type="date"
              />
              <ValidatedField
                id="tax-tariff-tranche-history-taxTariffTrancheType"
                name="taxTariffTrancheType"
                data-cy="taxTariffTrancheType"
                label={translate('crawlerBackendApp.taxTariffTrancheHistory.taxTariffTrancheType')}
                type="select"
              >
                <option value="" key="0" />
                {taxTariffTranches
                  ? taxTariffTranches.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.type}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/tax-tariff-tranche-history"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TaxTariffTrancheHistoryUpdate;
